import { db, collection, doc, setDoc, getDoc } from '../firebase';
import { siteData } from '../data/allBaseData';

const SINGLETON_COLLECTIONS = {
  // Regular singletons
  business: 'singleton',
  about: 'singleton',
  hero: 'singleton',
  catering: 'singleton',
  // Array-based singletons
  gallery: 'items',
  reviews: 'items',
  stats: 'items'
};

const initializeFirestore = async () => {
  try {
    console.log('Starting Firestore initialization...');

    for (const [collectionName, docType] of Object.entries(SINGLETON_COLLECTIONS)) {
      const docRef = doc(collection(db, collectionName), 'singleton');
      const docSnap = await getDoc(docRef);

      // Only initialize if document doesn't exist
      if (!docSnap.exists()) {
        console.log(`Initializing ${collectionName} data...`);
        
        // Handle array-based collections differently
        if (docType === 'items') {
          await setDoc(docRef, {
            items: siteData[collectionName],
            lastUpdated: new Date(),
            isActive: true
          });
        } else {
          // Regular singleton documents
          await setDoc(docRef, {
            ...siteData[collectionName],
            lastUpdated: new Date(),
            isActive: true
          });
        }
        
        console.log(`${collectionName} data initialized`);
      } else {
        console.log(`${collectionName} data already exists, skipping initialization`);
      }
    }

    console.log('Firestore initialization complete.');
  } catch (error) {
    console.error('Error in initializeFirestore:', error);
    throw error;
  }
};

export default initializeFirestore; 